import type { ApiRequestHelpers } from "./useHttpClient";
import type {
  LastMessageByUser,
  Message,
  MessagesCountData,
  PaginationQuery,
  PaginationResponse,
  Response,
  UserIdentifier,
} from "~/types/api";

export function createMessageApi({ getRequest, postRequest, getPaginationRequest }: ApiRequestHelpers) {
  /** Fetches the latest message per employee conversation. */
  const messages = () => getRequest<PaginationResponse<LastMessageByUser>>("/messages");

  /** Fetches the latest message per patient conversation. */
  const patientMessages = () => getRequest<PaginationResponse<LastMessageByUser>>("/messages/patients");

  const messageCount = (signal?: AbortSignal) => getRequest<Response<MessagesCountData>>("/messages/count", { signal });

  const messagesWithEmployee = (userId: UserIdentifier, pagination: PaginationQuery) =>
    getPaginationRequest<Message>(`/messages/${userId}?type=employee`, pagination);

  const messagesWithPatient = (userId: UserIdentifier, pagination: PaginationQuery) =>
    getPaginationRequest<Message>(`/messages/${userId}?type=patient`, pagination);

  const sendMessageToEmployee = (userId: UserIdentifier, message: string) =>
    postRequest<Response<Message>>(`/messages/${userId}?type=employee`, {
      message: message,
    });

  const sendMessageToPatient = (userId: UserIdentifier, message: string) =>
    postRequest<Response<Message>>(`/messages/${userId}?type=patient`, {
      message: message,
    });

  return {
    messages,
    patientMessages,
    messageCount,
    messagesWithEmployee,
    messagesWithPatient,
    sendMessageToEmployee,
    sendMessageToPatient,
  };
}

export type MessageApi = ReturnType<typeof createMessageApi>;
